import React, { useState, useEffect } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import Navbar from "../../Components/Navbar/Navbar";
import Table from "../../Components/TableTemplate/Table";
import ClickableRowTable from "../../Components/TableTemplate/OneTable";
import DeleteModal from "../../Components/Modals/DeleteModal";
import Select from "react-select";
import Moment from "moment";
import {
  getType,
  numberFormat,
  getTodayDateISO,
  selectDropdownStyle,
  selectDropdownStyleWithPortal,
  TokenExpiry,
  toastStyle,
  formatDateNoTime,
} from "../../Helpers/Utils/Common";
import { usePersistedState } from "../../Helpers/Utils/UsePersistedState";
import { CSVLink } from "react-csv";
import downloadIcon from "../../Assets/Images/download_icon.png";
import "./ProjectExpenses.css";
import "../Purchases/PurchaseOrders/PurchaseOrders.css";
import { searchProject } from "./../../Helpers/apiCalls/Manage/Projects";
import { searchPartner } from "../../Helpers/apiCalls/Manage/PartnerAPI";
import { getAllSuppliers } from "../../Helpers/apiCalls/suppliersApi";
import {
  searchProjectExpense,
  deleteProjectExpense,
  updateStatusProjectExpense,
} from "./../../Helpers/apiCalls/ProjectInvoice/ProjectExpenseApi";
import { getDistributor } from "../../Helpers/apiCalls/Distributor/DistributorApi";
import { getAllExpenseType } from "../../Helpers/apiCalls/expensetypesApi";
import { isNamedImports } from "typescript";

export default function ProjectExpenses() {
  const [inactive, setInactive] = useState(true);
  let navigate = useNavigate();
  const location = useLocation();
  const userType = getType();
  const [tableData, setTableData] = useState([]);
  const [projects, setProjects] = useState([]);
  const [partners, setPartners] = useState([]);
  const [allDistributors, setAllDistributors] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  const [projectId, setProjectId] = useState("");
  const [selectedProject, setSelectedProject] = usePersistedState("projexp_proj",null);
  const [selectedDistributor, setSelectedDistributor] = usePersistedState("projexp_distributor",null);
  const [selectedSupplier, setSelectedSupplier] = usePersistedState("projexp_supplier",null);
  const [accountTypes, setAccountTypes] = useState([]);
  const [selectedAccountType, setSelectedAccountType] = usePersistedState("projexp_acc",null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [indeterminate, setIndeterminate] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  const excelHeaders = [
    { label: "DATE", key: "project_expense_date" },
    { label: "PROJECT NAME", key: "name" },
    { label: "SUPPLIER", key: "supplier_name" },
    { label: "ACCOUNT TYPE", key: "name" },
    // { label: "AMOUNT", key: "amount" },
    // { label: "OTHER FEES", key: "other_fees" },
    { label: "GRAND TOTAL", key: "grand_total" },
    { label: "REMARKS", key: "remarks" },
    { label: "ADDED BY", key: "added_by_name" },
  ];

  /* FILTER CONFIGS */
  const [filterConfig, setFilterConfig] = usePersistedState("projexp_filters",{
    status: "pending",
    distributor_id: "",
    // franchise: "",
    // tabKey: "",
    // project_id: "",
    // franchised_on_from: "",
    // franchised_on_to: "",
  });

  const handleTabSelect = (tabKey) => {
    var newFilterConfig = {
      tab: tabKey,
      project_id: "",
      distributor_id: "",
      supplier_id: "",
      expense_type_id: "",
      expense_type_name: "",
    };

    setSelectedProject(null);
    setSelectedDistributor(null);
    setSelectedSupplier(null);
    setSelectedAccountType(null);

    switch (tabKey) {
      case "pending":
        setTableData([]);
        newFilterConfig.status = "pending";
        setFilterConfig(() => {
          return newFilterConfig;
        });
        break;
      case "approved":
        setTableData([]);
        newFilterConfig.status = "approved";
        setFilterConfig(() => {
          return newFilterConfig;
        });
        break;
      case "paid":
        setTableData([]);
        newFilterConfig.status = "paid";
        setFilterConfig(() => {
          return newFilterConfig;
        });
        break;
      // case "disapproved":
      //   setTableData([]);
      //   newFilterConfig.status = "disapproved";
      //   setFilterConfig(() => {
      //     return newFilterConfig;
      //   });
      //   break;
      case "all":
        setTableData([]);
        // newFilterConfig.status = "";
        setFilterConfig(() => {
          return newFilterConfig;
        });
        break;
      default:
        setTableData([]);
        break;
    }
  };

  async function fetchDistributors() {
    setAllDistributors([]);
    const response = await getDistributor();
    if (response.data) {
      const res = response.data.data.map((row) => {
        return {
          value: row.id,
          label: row.name,
        }
      })
      setAllDistributors([{value: '', label: 'All Distributors'}, ...res]);
    }
  }

  async function fetchProjects() {
    setShowLoader(true);
    setProjects([]);

    const response = await searchProject({});
    if (response.error) {
      if (response.error.data.status !== 404) {
        TokenExpiry(response.error);
      }
    } else {
      var projects = response.data.data.map((data) => {
        var info = {};
        info.label = data.name;
        info.value = data.id;
        return info;
      });
      setProjects([{ label: "All Projects", value: "" }, ...projects]);
    }

    setShowLoader(false);
  }

  async function fetchPartners() {
    setShowLoader(true);
    setPartners([]);

    const response = await searchPartner(null);
    if (response.error) {
      if (response.error.data.status !== 404) {
        TokenExpiry(response.error);
      }
    } else {
      var partners = response.data.data.map((data) => {
        var info = {};
        info.label = data.name;
        info.value = data.id;
        return info;
      });
      setPartners([{ label: "All Partners", value: "" }, ...partners]);
    }

    setShowLoader(false);
  }

  async function fetchAllSuppliers() {
    setSuppliers([]);
    const response = await getAllSuppliers();
    if (response.data) {
      const res = response.data.data.map((row) => {
        return {
          value: row.id,
          label: row.trade_name,
        };
      });
      setSuppliers(res);
    }
  }

   async function fetchAccountTypes() {
     console.log("fetchAccountTypes function called");
     try {
       const response = await getAllExpenseType();
       console.log("Account Types Response:", response);
       if (response && response.data) {
         const types = response.data.map((type) => ({
           label: type.name,
           value: type.id,
         }));
         const accountTypeOptions = [{ label: "All Account Types", value: "" }, ...types];
         console.log("Account Type Options:", accountTypeOptions);
         setAccountTypes(accountTypeOptions);
       }
     } catch (error) {
       console.error("Error fetching account types:", error);
       setAccountTypes([{ label: "All Account Types", value: "" }]);
    }
  }

  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    const newSelectedRows = tableData.map((row) => ({
      ...row,
      selected: checked,
    }));
    setSelectedRows(newSelectedRows);
    setIndeterminate(false);
  };

  const handleRowCheckboxChange = (e, row) => {
    const checked = e.target.checked;
    const newSelectedRows = selectedRows.map((r) =>
      r.id === row.id ? { ...r, selected: checked } : r
    );
    setSelectedRows(newSelectedRows);

    const selectedCount = newSelectedRows.filter((r) => r.selected).length;
    setSelectAll(selectedCount === tableData.length);
    setIndeterminate(
      selectedCount > 0 && selectedCount < tableData.length
    );
  };

  async function handleBulkProjectExpenseAction(action) {
    const status = action === "approve" ? "approved" : "disapproved";
    const selectedIds = selectedRows
      .filter((row) => row.selected)
      .map((row) => row.id);

    if (selectedIds.length === 0) {
      toast.error(
        `Please select at least one project expense to be ${status}.`,
        {
          style: toastStyle(),
        }
      );
      return;
    }

    setShowLoader(true);

    try {
      const updatePromises = selectedIds.map((id) =>
        updateStatusProjectExpense(id, status)
      );
      const responses = await Promise.all(updatePromises);

      const allSuccessful = responses.every((res) => res.data);

      if (allSuccessful) {
        toast.success(
          `Project expenses ${
            status.charAt(0).toUpperCase() + status.slice(1)
          } successfully!`,
          {
            style: toastStyle(),
          }
        );
        fetchData();
      } else {
        toast.error("Some updates failed. Please check and try again.", {
          style: toastStyle(),
        });
      }
    } catch (error) {
      toast.error("An error occurred while updating the status.", {
        style: toastStyle(),
      });
    } finally {
      setShowLoader(false);
    }
  }

  async function fetchData() {
    setShowLoader(true);
    setTableData([]);
    const response = await searchProjectExpense(filterConfig);
    if (response.data) {
      var allData = response.data.data.map((data) => {
        var info = data;
        info.added_on =
          data.added_on !== "0000-00-00" ? formatDateNoTime(data.added_on) : "";
        info.project_expense_date = formatDateNoTime(data.project_expense_date);
        // Format PE NO as "PE - {number}"
        info.project_expense_no = data.project_expense_no
          ? `PE - ${data.project_expense_no}`
          : `PE - ${data.id}`;
        info.amount = numberFormat(data.amount);
        info.other_fees = numberFormat(data.other_fees);
        info.grand_total = numberFormat(data.grand_total);
        info.balance = numberFormat(data.balance);
        info.paid_amount = data.paid_amount
          ? numberFormat(data.paid_amount)
          : "0.00";
        // Map account type name - check multiple possible field names from API
        info.type = data.expense_type_name || data.type || data.account_type || data.expense_type_id || "";
        return info;
      });
      setTableData(allData);
    } else if (response.error) {
      if (response.error.data.status !== 404) {
        TokenExpiry(response.error);
      }
    }
    setShowLoader(false);
  }

  async function handleDeletePI() {
    const response = await deleteProjectExpense(projectId);

    if (response.data) {
      toast.success("Project Expense Deleted Successfully!", {
        style: toastStyle(),
      });
      setShowDeleteModal(false);
      fetchData();
      // setTimeout(() => refreshPage(), 1000);
    } else {
      toast.error("Error Deleting Project Expense", {
        style: toastStyle(),
      });
    }
  }

  function goToPayment(mode, row) {
    navigate(`/se/paysuppliers/add/${mode}`, {
      state: {
        supplier_id: row.supplier_id,
        supplierName: row.supplier_name,
        payee: row.supplier_name,
        preselect_id: row.id,
        preselect_type: "project_expense",
      },
    });
  }

  // function handleSelectChange(e, id, franchisee_id, balance) {
  function handleSelectChange(e, row) {
    if (e.target.value === "edit-pi") {
      navigate("edit/" + row.id);
    } else if (e.target.value === "print-pi") {
      navigate("print/" + row.id);
    } else if (e.target.value === "delete-pi") {
      setProjectId(row.id);
      handleShowDeleteModal();
    } else if (e.target.value === "view") {
      navigate("view/" + row.id + "/" + row.status);
    } else if (e.target.value === "paybank-pe") {
      goToPayment("bank", row);
    } else if (e.target.value === "paycash-pe") {
      goToPayment("cash", row);
    } else if (e.target.value === "paycheck-pe") {
      goToPayment("check", row);
    } else if (e.target.value === "paygcash-pe") {
      goToPayment("gcash", row);
    } else if (e.target.value === "paycreditcard-pe") {
      goToPayment("credit_card", row);
    }
  }

  function handleToCSV() {
    return (
      <CSVLink
        data={tableData}
        headers={excelHeaders}
        filename={`ProjectExpense_${Moment().format("YYYY-MM-DD")}.csv`}
        style={{ textDecoration: "none", color: "#ffffff" }}
      >
        Export to CSV
      </CSVLink>
    );
  }
  {/* <Row>
    <Col className="d-flex justify-content-end mb-3">
      <div className="justify-content-center align-items-center ">
        <CSVLink
          className="button-primary px-3 py-3 justify-content-center align-items-center download-csv"
          data={tableData}
          headers={excelHeaders}
          target="_blank"
          filename={`${getTodayDateISO()} Project Expense`}
        >
          <span className="me-2">
            <img width={20} height={20} src={downloadIcon} alt=""></img>
          </span>
          Download Excel
        </CSVLink>
      </div>
    </Col>
  </Row> */}

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option value="" hidden selected>
          Select
        </option>
        {(userType === "admin" || userType === "finance_accounting_officer")  && (
          <>
            <option value="view" className="color-options">
              View
            </option>
            {row.status === "approved" && row.supplier_id && (
              <>
                <option value="paybank-pe" className="color-options">
                  Bank to Bank
                </option>
                <option value="paycash-pe" className="color-options">
                  Cash
                </option>
                <option value="paycheck-pe" className="color-options">
                  Check
                </option>
                <option value="paygcash-pe" className="color-options">
                  Gcash
                </option>
                <option value="paycreditcard-pe" className="color-options">
                  Credit Card
                </option>
              </>
            )}
            {(row?.status !== "approved" && row?.status !== "paid") &&(
              <>
                <option value="edit-pi" className="color-options">
                  Edit
                </option>
              </>
            )}
            {(row.status === "pending") && (
              <>
                <option value="delete-pi" className="color-red">
                  Delete
                </option>
              </>
            )}
          </>
        )}
      </Form.Select>
    );
  }

  function handleRowClick(row) {
    if (row && row.id) {
      window.open(`projectexpense/view/${row.id}/${row.status}`, "_blank");
    }
  }

  // function ViewBtn(row) {
  //   return (
  //     <button
  //       type="button"
  //       className="btn btn-sm view-btn-table"
  //       onClick={(e) => navigate("view/" + row.id + "/" + row.status)}
  //     >
  //       View
  //     </button>
  //   );
  // }

  useEffect(() => {
    fetchProjects();
    fetchPartners();
    fetchAllSuppliers();
    fetchDistributors();
    fetchAccountTypes();
  }, []);

  useEffect(() => {
    setSelectedRows(tableData.map((row) => ({ ...row, selected: false })));
    setSelectAll(false);
    setIndeterminate(false);
  }, [tableData]);

  useEffect(() => {
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  // Handle URL parameters for tab selection
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");

    if (tab && tab !== filterConfig.status) {
      handleTabSelect(tab);
    }
  }, [location]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"EXPENSE"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={6}>
            <h1 className="page-title">PROJECT EXPENSE</h1>
          </Col>
          <Col xs={6} className="d-flex justify-content-end">
          <button className="add-btn text-center">{handleToCSV()}</button>

            <button
              className="add-btn"
              onClick={() => navigate("/projectexpense/add")}
            >
              Add
            </button>
          </Col>
        </Row>
        

        <Tabs
          activeKey={filterConfig.status}
          defaultActiveKey={filterConfig.status}
          id="PO-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="pending" title="FOR APPROVAL">
            {/* filters */}
            <div className="my-2 ms-2 PO-filters PI-filters d-flex">

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Project"
                styles={selectDropdownStyleWithPortal}
                value={selectedProject}
                options={projects}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  setSelectedProject(e);
                  setFilterConfig((prev) => (
                    { ...prev, project_id: e.value }
                  ));
                }}
              />

              {/* <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Distributor"
                styles={selectDropdownStyle}
                value={selectedDistributor}
                options={allDistributors}
                onChange={(e) => {
                  setSelectedDistributor(e);
                  setFilterConfig((prev) => (
                    { ...prev, distributor_id: e.value }
                  ));
                }}
              /> */}
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Supplier"
                styles={selectDropdownStyleWithPortal}
                value={selectedSupplier}
                options={suppliers}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  setSelectedSupplier(e);
                  setFilterConfig((prev) => (
                    { ...prev, supplier_id: e.value }
                  ));
                }}
              />

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Account Type"
                styles={selectDropdownStyleWithPortal}
                value={selectedAccountType}
                options={accountTypes}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  setSelectedAccountType(e);
                  setFilterConfig((prev) => (
                    { ...prev, expense_type_name: e.value } //will change it once the backend already left join expense_type_name and will change this to expense_type_name
                  ));
                }}
              />
            </div>
            {/* content */}
            <div className="">
              <Table
                tableHeaders={[
                  "SELECT",
                  "PE NO",
                  "PE DATE",
                  "PROJECT NAME",
                  "SUPPLIER",
                  "TYPE",
                  "TOTAL",
                  "REMARKS",
                  "ADDED BY",
                  "ACTIONS",
                ]}
                headerSelector={[
                  "select",
                  "project_expense_no",
                  "project_expense_date",
                  "name",
                  "supplier_name",
                  "expense_type_name",  //change to expense_type_name once the backend already left join expense_type_name
                  "grand_total",
                  "remarks",
                  "added_by_name",
                ]}
                tableData={tableData}
                // ViewBtn={(row) => ViewBtn(row)}
                ActionBtn={(row) => ActionBtn(row, "pending")}
                selectAll={selectAll}
                indeterminate={indeterminate}
                handleSelectAllChange={handleSelectAllChange}
                handleRowCheckboxChange={handleRowCheckboxChange}
                selectedRows={selectedRows}
                showLoader={showLoader}
                withActionData={false}
              />
            </div>
          </Tab>
          <Tab eventKey="approved" title="UNPAID">
            {/* filters */}
            <div className="my-2 ms-2 PO-filters PI-filters d-flex">
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Project"
                styles={selectDropdownStyleWithPortal}
                value={selectedProject}
                options={projects}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  setSelectedProject(e);
                  setFilterConfig((prev) => {
                    return { ...prev, project_id: e.value };
                  });
                }}
              />

              {/* <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Distributor"
                styles={selectDropdownStyle}
                value={selectedDistributor}
                options={allDistributors}
                onChange={(e) => {
                  setSelectedDistributor(e);
                  setFilterConfig((prev) => {
                    return { ...prev, distributor_id: e.value };
                  });
                }}
              /> */}
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Supplier"
                styles={selectDropdownStyleWithPortal}
                value={selectedSupplier}
                options={suppliers}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  setSelectedSupplier(e);
                  setFilterConfig((prev) => {
                    return { ...prev, supplier_id: e.value };
                  });
                }}
              />

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Account Type"
                styles={selectDropdownStyleWithPortal}
                value={selectedAccountType}
                options={accountTypes}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  setSelectedAccountType(e);
                  setFilterConfig((prev) => (
                    { ...prev, expense_type_name: e.value } //will change it once the backend already left join expense_type_name and will change this to expense_type_name
                  ));
                }}
              />

            </div>

            {/* content */}
            <div className="">
              <Table
                tableHeaders={[
                  // "SELECT",
                  "PE NO",
                  "PE DATE",
                  "PROJECT NAME",
                  "SUPPLIER",
                  "TYPE",
                  "TOTAL",
                  "REMARKS",
                  "ADDED BY",
                  "ACTIONS",
                ]}
                headerSelector={[
                  // "select",
                  "project_expense_no",
                  "project_expense_date",
                  "name",
                  "supplier_name",
                  "expense_type_name", //change to expense_type_name once the backend already left join expense_type_name
                  "grand_total",
                  "remarks",
                  "added_by_name",
                ]}
                tableData={tableData}
                // ViewBtn={(row) => ViewBtn(row)}
                ActionBtn={(row) => ActionBtn(row, "approved")}
                // selectAll={selectAll}
                // indeterminate={indeterminate}
                // handleSelectAllChange={handleSelectAllChange}
                // handleRowCheckboxChange={handleRowCheckboxChange}
                // selectedRows={selectedRows}
                showLoader={showLoader}
                withActionData={false}
              />
            </div>
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="paid" title="PAID">
            {/* filters */}
            <div className="my-2 ms-2 PO-filters PI-filters d-flex">
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Project"
                styles={selectDropdownStyleWithPortal}
                value={selectedProject}
                options={projects}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  setSelectedProject(e);
                  setFilterConfig((prev) => {
                    return { ...prev, project_id: e.value };
                  });
                }}
              />

              {/* <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Distributor"
                styles={selectDropdownStyle}
                value={selectedDistributor}
                options={allDistributors}
                onChange={(e) => {
                  setSelectedDistributor(e);
                  setFilterConfig((prev) => {
                    return { ...prev, distributor_id: e.value };
                  });
                }}
              /> */}
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Supplier"
                styles={selectDropdownStyleWithPortal}
                value={selectedSupplier}
                options={suppliers}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  setSelectedSupplier(e);
                  setFilterConfig((prev) => {
                    return { ...prev, supplier_id: e.value };
                  });
                }}
              />

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Account Type"
                styles={selectDropdownStyleWithPortal}
                value={selectedAccountType}
                options={accountTypes}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  setSelectedAccountType(e);
                  setFilterConfig((prev) => (
                    { ...prev, expense_type_name: e.value } //will change it once the backend already left join expense_type_name and will change this to expense_type_name
                  ));
                }}
              />

            </div>

            {/* content */}
            <div className="sales-tbl">
              <ClickableRowTable
                tableHeaders={[
                  // "-",
                  "PE NO",
                  "PE DATE",
                  "PROJECT NAME",
                  "SUPPLIER",
                  "TYPE",
                  "TOTAL",
                  "REMARKS",
                  "ADDED BY",
                ]}
                headerSelector={[
                  // "-",
                  "project_expense_no",
                  "project_expense_date",
                  "name",
                  "supplier_name",
                  "expense_type_name", //change to expense_type_name once the backend already left join expense_type_name
                  "grand_total",
                  "remarks",
                  "added_by_name",
                ]}
                tableData={tableData}
                rowClickHandler={handleRowClick} 
                showLoader={showLoader}
              />
            </div>
            <div className="mb-2" />
          </Tab>
          {/* <Tab eventKey="disapproved" title="DISAPPROVED">
            <div className="my-2 ms-2 PO-filters PI-filters d-flex">
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Project"
                styles={selectDropdownStyle}
                value={selectedProject}
                options={projects}
                onChange={(e) => {
                  setSelectedProject(e);
                  setFilterConfig((prev) => {
                    return { ...prev, project_id: e.value };
                  });
                }}
              />

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Distributor"
                styles={selectDropdownStyle}
                value={selectedDistributor}
                options={allDistributors}
                onChange={(e) => {
                  setSelectedDistributor(e);
                  setFilterConfig((prev) => {
                    return { ...prev, distributor_id: e.value };
                  });
                }}
              />
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Supplier"
                styles={selectDropdownStyle}
                value={selectedSupplier}
                options={suppliers}
                onChange={(e) => {
                  setSelectedSupplier(e);
                  setFilterConfig((prev) => {
                    return { ...prev, supplier_id: e.value };
                  });
                }}
              />
            </div>

            <div className="">
              <Table
                tableHeaders={[
                  "DATE",
                  "PROJECT NAME",
                  "SUPPLIER",
                  "AMOUNT",
                  "OTHER FESS",
                  "GRAND TOTAL",
                  "REMARKS",
                  "ADDED BY",
                  "ACTIONS",
                ]}
                headerSelector={[
                  "project_expense_date",
                  "name",
                  "supplier_name",
                  "amount",
                  "other_fees",
                  "grand_total",
                  "remarks",
                  "added_by_name",
                ]}
                tableData={tableData}
                ActionBtn={(row) => ActionBtn(row, "disapproved")}
                showLoader={showLoader}
                withActionData={false}
              />
            </div>
            <div className="mb-2" />
          </Tab> */}
          <Tab eventKey="all" title="ALL">
            {/* filters */}
            <div className="my-2 ms-2 PO-filters PI-filters d-flex">
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Project"
                styles={selectDropdownStyleWithPortal}
                value={selectedProject}
                options={projects}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  setSelectedProject(e);
                  setFilterConfig((prev) => {
                    return { ...prev, project_id: e.value };
                  });
                }}
              />

              {/* <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Distributor"
                styles={selectDropdownStyle}
                value={selectedDistributor}
                options={allDistributors}
                onChange={(e) => {
                  setSelectedDistributor(e);
                  setFilterConfig((prev) => {
                    return { ...prev, distributor_id: e.value };
                  });
                }}
              /> */}
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Supplier"
                styles={selectDropdownStyleWithPortal}
                value={selectedSupplier}
                options={suppliers}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  setSelectedSupplier(e);
                  setFilterConfig((prev) => {
                    return { ...prev, supplier_id: e.value };
                  });
                }}
              />

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Account Type"
                styles={selectDropdownStyleWithPortal}
                value={selectedAccountType}
                options={accountTypes}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  setSelectedAccountType(e);
                  setFilterConfig((prev) => (
                    { ...prev, expense_type_name: e.value } //will change it once the backend already left join expense_type_name and will change this to expense_type_name
                  ));
                }}
              />

            </div>

            {/* content */}
            <div className="">
              <Table
                tableHeaders={[
                  // "SELECT",
                  "PE NO",
                  "PE DATE",
                  "PROJECT NAME",
                  "SUPPLIER",
                  "TYPE",
                  "TOTAL",
                  "REMARKS",
                  "STATUS",
                  "ADDED BY",
                  "ACTIONS",
                ]}
                headerSelector={[
                  // "select",
                  "project_expense_no",
                  "project_expense_date",
                  "name",
                  "supplier_name",
                  "expense_type_name", //change to expense_type_name once the backend already left join expense_type_name
                  "grand_total",
                  "remarks",
                  "status",
                  "added_by_name",
                ]}
                tableData={tableData}
                // ViewBtn={(row) => ViewBtn(row)}
                ActionBtn={(row) => ActionBtn(row, "all")}
                // selectAll={selectAll}
                // indeterminate={indeterminate}
                // handleSelectAllChange={handleSelectAllChange}
                // handleRowCheckboxChange={handleRowCheckboxChange}
                // selectedRows={selectedRows}
                showLoader={showLoader}
                withActionData={false}
              />
            </div>
            <div className="mb-2" />
          </Tab>
        </Tabs>

        {filterConfig.status === "pending" && selectedRows.some((row) => row.selected) && (
          <div className="d-flex justify-content-end mt-3">
            <button
              type="button"
              className="button-primary me-2"
              onClick={() => handleBulkProjectExpenseAction("approve")}
            >
              Approve
            </button>
            <button
              type="button"
              className="button-warning me-2"
              onClick={() => handleBulkProjectExpenseAction("disapprove")}
            >
              Disapprove
            </button>
          </div>
        )}
        <div className="mb-2" />
      </div>
      <DeleteModal
        show={showDeleteModal}
        onHide={() => handleCloseDeleteModal()}
        text="project expense"
        onDelete={() => handleDeletePI()}
      />
    </div>
  );
}